import type { FC, PropsWithChildren } from 'react';
import { useEffect } from 'react';
import { SplashScreen } from 'src/components/splash-screen';
import { useAuthContext } from 'src/hooks/use-context';
import { paths } from 'src/paths';
import { searchParam } from 'src/utils/search-params';

/**
 * Guard redirects if user is not authenticated
 */
export const NoAuthGuard: FC<PropsWithChildren> = (props) => {
  const { children } = props;
  const { authenticated } = useAuthContext();

  useEffect(
    () => {
      if (authenticated) {
        console.info('[no-auth-guard] Redirecting (authenticated)');
        // returnTo could be an absolute path
        window.location.href = searchParam('returnTo') ?? paths.index;
      }
    },
    // IMPORTANT: redirect only on authentication changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [authenticated]
  );

  // waiting for redirect
  if (authenticated) return <SplashScreen />;

  // guard passed
  return <>{children}</>;
};
